import { useNavigate } from 'react-router-dom';

const NoPage = () => {
	const navigate = useNavigate();
	navigate('/');
};

export default NoPage;
